export const editString = (text) => {
    return text
            .replaceAll("%", "")   // Процент
            // .replaceAll(" ", "")   // Пробел
            .replaceAll("\t", "")  // Табуляция (заменяем на пробел)
            .replaceAll("\n", "")  // Переход строки (заменяем на пробел)
            .replaceAll("\r", "")  // Возврат каретки (заменяем на пробел)
            // .replaceAll("!", "")   // Восклицательный знак
            .replaceAll("\"", "")  // Двойная кавычка
            .replaceAll("#", "")   // Октоторп, решетка
            .replaceAll("$", "") // Знак доллара
            .replaceAll("&", "")   // Амперсанд
            .replaceAll("'", "")   // Одиночная кавычка
            .replaceAll("(", "") // Открывающаяся скобка
            .replaceAll(")", "") // Закрывающаяся скобка
            .replaceAll("*", "") // Звездочка
            .replaceAll("+", "") // Знак плюс
            .replaceAll(",", "")   // Запятая
            // .replaceAll("-", "")   // Дефис
            .replaceAll(".", "") // Точка
            .replaceAll("/", "")   // Слеш, косая черта
            .replaceAll(":", "")   // Двоеточие
            .replaceAll(";", "")   // Точка с запятой
            .replaceAll("<", "")   // Открывающаяся угловая скобка
            .replaceAll("=", "")   // Знак равно
            .replaceAll(">", "")   // Закрывающаяся угловая скобка
            .replaceAll("?", "") // Вопросительный знак
            .replaceAll("@", "")   // At sign, по цене, собачка
            .replaceAll("[", "") // Открывающаяся квадратная скобка
            .replaceAll("\\\\", "") // Одиночный обратный слеш '\'
            .replaceAll("]", "") // Закрывающаяся квадратная скобка
            .replaceAll("^", "") // Циркумфлекс
            .replaceAll("_", "")   // Нижнее подчеркивание
            .replaceAll("`", "")   // Гравис
            .replaceAll("{", "") // Открывающаяся фигурная скобка
            .replaceAll("|", "") // Вертикальная черта
            .replaceAll("}", "") // Закрывающаяся фигурная скобка
            .replaceAll("~", "");  // Тильда
}
